import React from 'react';
import { Star, BadgeCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProviderCard = ({ provider }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/booking/${provider.id}`)}
      className="flex-shrink-0 w-[220px] sm:w-[240px] bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow duration-200 group"
    >
      {/* Image */}
      <div className="relative h-[180px] overflow-hidden">
        <img
          src={provider.photo}
          alt={provider.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {(provider.is_top || provider.isTop) && (
          <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm text-xs font-semibold text-gray-800 px-2.5 py-1 rounded-full shadow-sm">
            Top prestataire
          </div>
        )}
        {(provider.is_pro || provider.isPro) && (
          <div className="absolute top-3 right-3 bg-blue-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
            PRO
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-4">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-base font-semibold text-gray-900">{provider.name}</h3>
          <span className="text-sm font-bold text-gray-900">{provider.price} DH</span>
        </div>
        <p className="text-sm text-gray-500 mb-2">{provider.skill}</p>

        {/* Rating */}
        <div className="flex items-center gap-1 mb-3">
          <Star size={14} className="text-yellow-400 fill-yellow-400" />
          <span className="text-sm font-bold text-gray-900">{provider.rating}</span>
          <span className="text-xs text-gray-400">({provider.reviews_count || provider.reviews} avis)</span>
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-1.5">
          {provider.tags.slice(0, 2).map((tag, idx) => (
            <span
              key={idx}
              className="text-[11px] font-medium text-gray-600 bg-gray-50 px-2 py-0.5 rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProviderCard;
